import cardReportDesc from './cardReportDesc';
export default {
  name: 'CardReport',
  components: {
    'card-report-desc': cardReportDesc
  },
  props: {
    userInfo: Object
  },
  data: function data() {
    return {
      reportState: 0
    };
  },
  methods: {
    changeState: function changeState(state) {
      // 1用户 2视频, 3:短视频 4 速配 5ins 举报
      if (state === 9) {
        this.reportState = state;
      } else {
        this.feedbackSend(state, '');
      }
    },
    closeReport: function closeReport() {
      this.reportState = 0;
    },
    feedbackSend: function feedbackSend(rs, desc) {
      var content = rs === 9 ? desc : this.$t("liveroom.personalCard.reportContent".concat(rs));
      this.$emit('feedbackSend', content, desc, rs);
    },
    hideReport: function hideReport() {
      this.$emit('changeReport');
    }
  }
};